import {configure} from 'mobx';

function configureMobX() {
  configure({
    enforceActions: 'never'
  });
}

export default configureMobX;
